import React from 'react'
import { Flex, Box } from 'grid-styled'
import { Field } from 'redux-form'
import {
  renderTextInput,
  renderValidThruInput,
  renderCardInput,
  renderCvcInput
} from '../../../utils/renderInputs'
import { validateCreditCardFlag } from '../EditPaymentForm/validators'
import { MasterCard, Visa, Elo, Amex } from 'app/elements/CardFlags'
import { Icon } from 'app/elements/Icon'
import {
  required,
  validateExpireDate,
  validateCVV,
  validateAmexCVV
} from '../../../utils/validators'
import { CardFlagList, CardFlagItem } from './styles'
import { labels } from './data.json'
import { deepCerise } from 'styles/settings/colors'

const CreditPaymentForm = ({ formValues }) => {
  const checkCreditCardFlag = cardNumber => {
    const creditCardFlag = validateCreditCardFlag(cardNumber)
    if (creditCardFlag) {
      return creditCardFlag
    } else {
      return undefined
    }
  }

  const creditCardFlag = checkCreditCardFlag(formValues.cardNumber)

  const validateSecurityCode =
    creditCardFlag === 'amex' ? [required, validateAmexCVV] : [required, validateCVV]

  return (
    <Flex direction="column">
      <Box width={[1, 380]} mb={[24, 28]}>
        <Field
          component={renderCardInput}
          label={labels.cardNumber}
          name="cardNumber"
          placeholder={labels.placeholder.cardNumber}
          validate={required}
          labelIcon={<Icon icon="lock" width="100" height="100" viewBox="0 0 100 100" />}
        />
        <CardFlagList>
          <CardFlagItem hideCard={creditCardFlag !== undefined && creditCardFlag !== 'elo'}>
            <Elo />
          </CardFlagItem>
          <CardFlagItem hideCard={creditCardFlag !== undefined && creditCardFlag !== 'master'}>
            <MasterCard />
          </CardFlagItem>
          <CardFlagItem hideCard={creditCardFlag !== undefined && creditCardFlag !== 'visa'}>
            <Visa />
          </CardFlagItem>
          <CardFlagItem hideCard={creditCardFlag !== undefined && creditCardFlag !== 'amex'}>
            <Amex />
          </CardFlagItem>
        </CardFlagList>
      </Box>
      <Box width={[1, 380]} mb={[17, 20]}>
        <Field
          component={renderTextInput}
          label={labels.yourName}
          placeholder={labels.placeholder.yourName}
          name="fullName"
          validate={required}
        />
      </Box>
      <Flex direction={['column', 'row']} width={[1, 380]}>
        <Box mb={[17, 20]} mr={33} width={[1, 200]}>
          <Field
            component={renderValidThruInput}
            label={labels.validThru}
            placeholder={labels.placeholder.validThru}
            name="validThru"
            validate={[required, validateExpireDate]}
          />
        </Box>
        <Box mb={[17, 37]} width={[1, 300]}>
          <Field
            component={renderCvcInput}
            label={labels.securityCode}
            placeholder={
              creditCardFlag === 'amex'
                ? labels.placeholder.amexSecurityCode
                : labels.placeholder.securityCode
            }
            name="cvv"
            validate={validateSecurityCode}
            tooltip="O código de segurança de seu cartão (CVV) é o número de 3 ou 4 dígitos localizado no verso da maioria dos cartões."
            tooltipColor={deepCerise}
            limitDigit={creditCardFlag === 'amex' ? 4 : 3}
            tooltipPositionRight
            endIcon={<Icon icon="info" width="100" height="100" viewBox="0 0 100 100" />}
          />
        </Box>
      </Flex>
    </Flex>
  )
}

export default CreditPaymentForm



// WEBPACK FOOTER //
// ./src/app/modules/PaymentForm/credit.js